/**
 * 認証・権限サービス
 */

import { doc, getDoc } from 'firebase/firestore';

import type { User } from '../types';
import { existingDb } from './firebase';

/** ユーザー情報を取得（role含む） - users は dot99 にあるため existingDb を使用 */
export async function getUserWithRole(uid: string): Promise<User | null> {
  const userRef = doc(existingDb, 'users', uid);
  const userDoc = await getDoc(userRef);

  if (!userDoc.exists()) {
    return null;
  }

  return userDoc.data() as User;
}

/** 管理者かどうかをチェック（admin または operator） */
export async function isAdmin(uid: string): Promise<boolean> {
  const user = await getUserWithRole(uid);
  return user?.role === 'admin' || user?.role === 'operator';
}

/** 運営者かどうかをチェック（operator のみ） */
export async function isOperator(uid: string): Promise<boolean> {
  const user = await getUserWithRole(uid);
  return user?.role === 'operator';
}
